/* eslint-disable react/prop-types */
import React from 'react';

import { Box } from '@material-ui/core';

import LogoCr from '../../../assets/images/LogoCliqueHorizontal.svg';
import { ImageContainer, CustomAppBar, MultipleImageContainer } from './styles';

export default function Header({ logoUrl, showCRLogo, color }) {
  return (
    <Box>
      <CustomAppBar
        position="static"
        elevation={0}
        style={{ backgroundColor: color }}
      >
        {showCRLogo && logoUrl ? (
          <MultipleImageContainer>
            <img alt="Logo" src={logoUrl} height="50px" />
            <img alt="Logo" src={LogoCr} height="50px" />
          </MultipleImageContainer>
        ) : (
          <ImageContainer>
            <img alt="Logo" src={logoUrl || LogoCr} height="50px" />
          </ImageContainer>
        )}
      </CustomAppBar>
    </Box>
  );
}
